// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4a43c964","239":"2401bf83","455":"98765957"}[chunkId] + ".chunk.js";
};